<template>
  <section class="feature">
    <div class="container">
      <a-typography-title :level="1">
        产品价值
      </a-typography-title>
      <a-row :gutter="[40,20]">
        <a-col v-for="item in expand.content"
               :xs="24" :lg="8">
          <div class="item">
            <a-typography-title :level="5">
              {{ item.title }}
            </a-typography-title>
            <a-typography-paragraph>
              {{ item.text }}
            </a-typography-paragraph>
          </div>
        </a-col>
      </a-row>
      <!-- <a-space :size="$Store.Public().isGridMatch('>=',$Enum.GridEnum.XL)?'large':'small'"> -->
        <!-- <a-button type="link" class="button_n_2"
                  @click="clickToStore()">
          立即注册体验
        </a-button> -->
        <!--<a-button type="link" class="button_1"-->
        <!--          @click="$Store.Page().openModal('modalFormCollection', 'deployment')">-->
        <!--  预约私有化部署-->
        <!--</a-button>-->
      <!-- </a-space> -->
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';

export default {
  name: 'product_feature',
  data(): DataInterface {
    return {
      expand: {
        content: [
          {
            title: '零改造',
            text: '提供无侵入日志采集专利技术，使开发者不受编程语言限制，无需框架适配或代码改造，只需提交Release的代码，即可低成本搭建具备自动扩缩容、按量计费、故障自愈等能力的分布式自治理系统。'
          },
          {
            title: '免运维',
            text: '实现部署、发布、性能、稳定性治理的全自动化，开发者无需对日志采集、算力规格、算力规模等进行配置，减少90%以上的手工运维、配置、发布等工作。'
          },
          {
            title: '低成本',
            text: '全流程自动化，基于发明专利的压测技术，自动识别成本最低的算力资源规格，实现高度弹性、按需付费，时刻保持算力资源高利用率，做到云资源成本最优化。'
          }
        ]
      }
    };
  },
  methods: {
    /**
     * 点击去商城
     */
    clickToStore(): void {
      // location.href = $Config.Href.cloud;
      open($Config.Href.cloud);
    },
    
    /**
     * 点击去云平台
     */
    clickToCloud(): void {
      // location.href = $Config.Href.cloudDemo;
      open($Config.Href.cloudDemo);
    }
  }
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}page/productInfraPilot/';

.feature {
  overflow: hidden;
  position: relative;
  padding: 0 @padding;
  background-color: @color_9;
  
  .container {
    position: relative;
    max-width: @grid_xl;
    padding: @space 0;
    margin: 0 auto;
    text-align: center;
  }
}


h1.ant-typography {
  position: relative;
  margin: 0;
  .font(center, @title, @color_12, @title, true);
}

.ant-row {
  margin: @margin 0 0;
  
  .ant-col {
    @w: 80px;
    
    .loop(@i) when (@i<=3) {
      &:nth-child(@{i}) {
        .item::before {
          background-position-x: -(-1+@i)*@w;
        }
      }
      .loop(@i+1);
    }
    .loop(1);
    
    .item {
      position: relative;
      width: 100%;
      max-width: 375px;
      height: 320px;
      padding: 20px 30px;
      margin: 0 auto;
      background-color: @color_white;
      border-radius: 3px;
      .shadow(0 0 10px fade(@color_black, 10));
      
      &:hover {
        &::before {
          .transform(scale(1.1));
        }
      }
      
      &::before {
        @h: 60px;
        content: '';
        display: block;
        width: @w;
        height: @h;
        margin: 0 auto;
        .bg('@{image}worth_icon.png', @w*3, @h);
        .transition(transform 1s);
      }
      
      h5.ant-typography {
        margin: @margin_mo 0 0;
        .font(center, @text_big, @color_12, @text_big, true);
      }
      
      div.ant-typography {
        margin: @margin_mo 0 0;
        .font(justify, @text+@line, @color_3, @text);
        .wordBreak();
      }
    }
  }
}

.ant-space {
  margin: @margin 0 0;
}

@media screen and (max-width: -1px+@grid_md) {
  .feature {
    .container {
      padding: @space_mo 0;
    }
  }
  
  h1.ant-typography {
    .font(center, @title_mo, @color_12, @title_mo, true);
  }
  
  .ant-row {
    margin: @margin_mo 0 0;
    
    .ant-col {
      .item {
        height: auto;
      }
    }
  }
}
</style>